const SPACE_DATA = {
		"u7007774":  [{space_js: "//yskdta.netvisioncloud.com/source/kf/source/gl/resource/l_gggb.js", space_src: "baidujs", space_type: "inters", space_id: "u7007774"}],
		"u7007775":  [{space_js: "//yskdta.netvisioncloud.com/source/lg/static/h/mm-h/production/hhd.js", space_src: "baidujs", space_type: "native", space_id: "u7007775"}],
		"u7007776":  [{space_js: "//yskdta.netvisioncloud.com/common/m_hinn_i_i/static/ig.js", space_src: "baidujs", space_type: "native", space_id: "u7007776"}],
		"u7007777":  [{space_js: "//yskdta.netvisioncloud.com/production/n/ijo_ojjj_j.js", space_src: "baidujs", space_type: "native", space_id: "u7007777"}],
};
export const SPACE_MAP = {
	Home_inter:  SPACE_DATA["u7007774"],
	Home_banner:  SPACE_DATA["u7007775"],
	Home_native:  SPACE_DATA["u7007776"],
	Home_native_center1:  SPACE_DATA["u7007777"],
	Detail_inter:  SPACE_DATA["u7007774"],
	Detail_banner:  SPACE_DATA["u7007775"],
	Detail_native:  SPACE_DATA["u7007776"],
	Detail_native_center1:  SPACE_DATA["u7007777"],
	Result_inter:  SPACE_DATA["u7007774"],
	Result_banner:  SPACE_DATA["u7007775"],
	Result_native:  SPACE_DATA["u7007776"],
	Result_native_center1:  SPACE_DATA["u7007777"],
}
export const ALL_SPACE_MAP = {
    H5_WSAI_VO_1 : {
		Home_inter:  SPACE_DATA["u7007774"],
		Home_banner:  SPACE_DATA["u7007775"],
		Home_native:  SPACE_DATA["u7007776"],
		Home_native_center1:  SPACE_DATA["u7007777"],
		Detail_inter:  SPACE_DATA["u7007774"],
		Detail_banner:  SPACE_DATA["u7007775"],
		Detail_native:  SPACE_DATA["u7007776"],
		Detail_native_center1:  SPACE_DATA["u7007777"],
		Result_inter:  SPACE_DATA["u7007774"],
		Result_banner:  SPACE_DATA["u7007775"],
		Result_native:  SPACE_DATA["u7007776"],
		Result_native_center1:  SPACE_DATA["u7007777"],
    },
    DEFAULT : {
		Home_inter:  SPACE_DATA["u7007774"],
		Home_banner:  SPACE_DATA["u7007775"],
		Home_native:  SPACE_DATA["u7007776"],
		Home_native_center1:  SPACE_DATA["u7007777"],
		Detail_inter:  SPACE_DATA["u7007774"],
		Detail_banner:  SPACE_DATA["u7007775"],
		Detail_native:  SPACE_DATA["u7007776"],
		Detail_native_center1:  SPACE_DATA["u7007777"],
		Result_inter:  SPACE_DATA["u7007774"],
		Result_banner:  SPACE_DATA["u7007775"],
		Result_native:  SPACE_DATA["u7007776"],
		Result_native_center1:  SPACE_DATA["u7007777"],
    },
};
